import LinkButton from '../../../components/LinkButton/LinkButton';
import { GITBOOK_LINK } from '../../../constants';
import { WINDOWS_LINK } from '../../../constants';
import { MAC_LINK } from '../../../constants';
import './MoreInfo.css'

const MoreInfo = () => {
  return (
    <div className='home-moreInfo'>
      <label className='home-moreInfo__title'>More info about dcrc - RaceX</label>
      <p className='home-moreInfo__desc'>
        The game is currently in Beta Testing and a public demo has been released .We look forward to feedback from the community as we continue to improve the gameplay and finalize the game tokenomics and the Web3 integration. <br/>
        Make sure you read our whitepaper and follow us on our social networks not to miss anything!
      </p>
      <div style={{position:'sticky', display:'flex', justifyContent:'center'}}>
        <a href={WINDOWS_LINK} target='_blank' className='home__btn__mint' style={{width:'160px', margin:'0'}}>Windows Demo</a>
        <a href={GITBOOK_LINK} target='_blank' className='home__btn__mint' style={{width:'160px', margin:'0'}}>Read Whitepaper</a>
      </div>
    </div>
      
  )
}
export default MoreInfo;